import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { portinColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortin } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "zipcode", "status", "batch_id", "last_updated"];

const VSPortinBatch = () => (
  <BatchDetail
    title="Portin"
    apiGet={__getPortin}
    client={CLIENTS.vs}
    columnsFactory={(ctx) => portinColumns({ ...ctx, showPlan: false, showAddress: true })}
    copyKeys={COPY_KEYS}
    exportAction="portin"
    retryOperation="portin"
    showTerminate
    getRowPath={(row) => `/vs/portin/${row.id}`}
  />
);

export default VSPortinBatch;
